import React from "react";
import clsx from "clsx";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ListItem from "@mui/material/ListItem";

import { DRAWER_WIDTH } from "../tools";
import { useLocation } from "react-router";
import { Typography } from "@mui/material";
import useClasses from "../useClasses";

const styles = (theme) => ({
  listItem: {
    color: theme.palette.text.secondary,
    justifyContent: "center",
    borderRadius: theme.shape.borderRadius,
  },
  listItemDesktop: {
    width: DRAWER_WIDTH,
    padding: theme.spacing(2),
  },
  listItemMobile: {},
  listItemIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    fontWeight: 500,
  },
  selectedIcon: {
    color: theme.palette.primary.main,
  },
  text: {
    width: `calc(${DRAWER_WIDTH}px - ${theme.spacing(1)})`,
    textAlign: "center",
  },
});

export default function MenuButton({
  id,
  title,
  icon,
  iconSelected = icon,
  func,
  paths,
}) {
  const classes = useClasses(styles);
  const theme = useTheme();
  const location = useLocation();
  const mobile = useMediaQuery(theme.breakpoints.down('lg'));
  return (
    <ListItem
      key={id}
      button
      onClick={func}
      className={clsx(classes.listItem, {
        [classes.listItemDesktop]: !mobile,
        [classes.listItemMobile]: mobile,
      })}
    >
      <div
        className={clsx(classes.listItemIcon, {
          [classes.selectedIcon]: paths.includes(location.pathname),
          [classes.unselectedIcon]: !paths.includes(location.pathname),
        })}
      >
        {paths.includes(location.pathname) ? iconSelected : icon}
        <div style={{ paddingBottom: 3 }} />
        <Typography className={classes.text} variant="subtitle2" noWrap>
          {title}
        </Typography>
      </div>
    </ListItem>
  );
}
